import {appkey, useDb} from '../config/env'
import {store,mutations} from "../store";

// import SDK from '../lib/NIM_Web_SDK_v6.8.0'
console.info("appkey=============",appkey);
class Nim {
    constructor(callback){
        this._account =store.imAccid;
        this._token = store.imToken;
        this.timer = null;
        this.reconnectNum = 0;
        this.init(callback);
    }

    init(callback){
        let _this = this;
        // if (window.nim) {
        //     window.nim.disconnect()
        // }
        // 初始化SDK
        window.nim = store.Nim = SDK.NIM.getInstance({
            debug: false,
            appKey: appkey,
            account: _this._account,
            token: _this._token,
            transports: ['websocket'],
            db: false,
            syncSessionUnread:true,
            onconnect: function onConnect(event) {
                console.info("nim 连接成功")
                store.socket.recodeImStatus();
                store.NimStatus = true
                store.networkWarning = ''
                if(store.socket){
                    store.socket.connect();
                }else{
                    if(store.historyMsgList.length==0){
                        store.socket.vHisMsgLists();
                    }
                }

            },
            onerror: function onError(event) {
                console.info("im连接异常",event);
                // store.NimStatus = false;
                // store.isInput =false;
                // store.networkWarning = 'Connection interrupted, Reconnecting...'
                // if(store.socket){
                //     store.socket.close();
                // }
                // store.Nim.connect()
            },
            onwillreconnect: function onWillReconnect(error) {
                console.info("网络正在重新连接",error)
                store.NimStatus = false;
                store.isInput =false;
                store.networkWarning = 'Channel disconnected, Reconnecting...'
            },
            ondisconnect: function onDisconnect(error) {
                console.info("云信彻底连接断开了",error)
                store.NimStatus = false;
                store.isInput =false;
                if(store.socket){
                    store.socket.close();
                }
                if(_this.reconnectNum<15){
                    store.networkWarning = 'Channel disconnected, Reconnecting...'
                    clearTimeout(_this.timer)
                    _this.timer = setTimeout(()=>{
                        console.info("云信尝试重连")
                        mutations.connectNim();
                        _this.reconnectNum++;
                    },8000)
                }else{
                    store.networkWarning = 'Channel disconnected,Please Reconnecting'
                }
                switch (error.code) {
                    // 账号或者密码错误, 请跳转到登录页面并提示错误
                    case 302:
                        // alert('帐号或密码错误', 'login')
                        break
                    default:
                        // alert("断开了");
                        console.info(error)
                      // mutations.connectNim();
                        break
                }
                // _this._opt.ondisconnect&&typeof _this._opt.ondisconnect =="function" &&  _this._opt.ondisconnect(error);
            },
            onsessions: function (data) {
                // console.info("onsessions")
                // console.info(data);
            },
            onupdatesession: function (data) {
                // console.info('onupdatesession')
                // _this.sendMsgReceipt(data.lastMsg)
                // console.info(data);
            },
            //  接收到的消息
            onmsg: function (data) {
                // console.info('收到的消息',data);
                mutations.setMsgList(data);
                // if(data){
                //     _this._opt.onmsg&&typeof _this._opt.onmsg =="function" &&  _this._opt.onmsg(data);
                // }
            },
            onupdatesysmsg(){
                // alert('收到系统通知');
            },
            onsysmsg(res){
                mutations.undoMsg(res);
                // console.info(res)
                // alert('收到系统通知2');
            },
            //自定义消息
            oncustomsysmsg(data){
                store.isInput = JSON.parse(data.content).value;
            },
            onsyncdone(){
                store.NimStatus = true;
                for(var i=0;i<store.noSendMsg.length;i++){
                    mutations.resendMsg(store.noSendMsg[i]);
                }
                store.noSendMsg = [];
                typeof callback=='function' &&callback();
            },
            onDeleteMsgSelf(res){
                console.info(res)
            }
        })
        window.nim.useDb = false
    }
}
export default Nim;
